<template>
    <div class="student-canvas" v-if="canvas2_is_ready && is_ready">
        <canvas-layout :stage="stage"
                       page="canvas"
                       v-if="is_ready">
            <canvas-stage-browser :active-stage="stage"
                                  @browse="changeStage"/>

            <div class="canvas-stages">

                <div class="stages-inner">
                    <student-canvas-stage v-for="stage in visible_stages" :key="stage.slug"
                                          :id="`stage-${stage.slug}`"
                                          :stage="stage"/>
                </div>

                <canvas-top-curve class="stage-bottom-curve" color="#fff"/>
            </div>

        </canvas-layout>
    </div>
</template>

<script>
import API from "@/API";
import jQuery from "jquery";
import {mapGetters} from "vuex";
import {mapActions} from "vuex";
import utils from "@/mixins/utils";
import CanvasLayout from "@/Layouts/Canvas2/CanvasLayout";
import CanvasStageBrowser from "@/Components/Canvas2/CanvasStageBrowser";
import CanvasTopCurve from "@/Others/Canvas2/CanvasTopCurve";
import ColorButton from "@/Components/Canvas2/ColorButton";
import StudentCanvasStage from "@/Components/Canvas2/StudentCanvasStage";

export default {
    name: "StudentCanvas",
    components: {
        StudentCanvasStage,
        ColorButton, CanvasTopCurve, CanvasStageBrowser, CanvasLayout},
    mixins: [utils],

    props: {
        canvas: {
            type: Object,
            default: () => null,
        },

    },

    data(){
        return {
            is_ready: false,
            stage: null,
        }
    },

    computed: {

        ...mapGetters('canvas2', ['canvas2_is_ready', 'stages', 'published_canvas_stages']),

        visible_stages(){
            if( this.$page.props.canvas_editable ){
                return this.stages;
            }
            return this.stages.filter((s) => this.published_canvas_stages.indexOf( s.slug ) >= 0 );
        },

    },


    watch: {
        canvas2_is_ready(ready){
            if( ready ){
                if( this.visible_stages.length === 0 ){
                    window.location = '/';
                }
            }
        }
    },

    methods: {

        ...mapActions('canvas2', ['initCanvas']),

        changeStage(stage){
            this.stage = stage.stage.slug;
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(`#stage-${this.stage}`).offset().top - jQuery('.canvas-stages').offset().top,
            }, 700);
        },

    },

    async beforeMount() {
        await this.initCanvas(this.canvas);
        this.stage = this.stages[0]?.slug ?? null;
    },

    mounted() {
        this.is_ready = true;
    }

}
</script>

<style lang="scss" scoped>
</style>
